module.exports = __webpack_public_path__ + "static/media/8839C544-653D-41C7-9B10-C96203AD0742.fd59e69a.png";